(function(){
  if (window.__thirdPartyQueued) return; window.__thirdPartyQueued = true;

  /* CYME CUSTOM START: page-type third-party vendor gate */
  var pathname = window.location && window.location.pathname ? window.location.pathname : '';
  var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  if (pathname.indexOf(routeRoot) === 0) {
    pathname = '/' + pathname.slice(routeRoot.length);
  }
  pathname = pathname.replace(/\/+$/, '') || '/';
  var pageType = window.themeVariables && window.themeVariables.settings
    ? window.themeVariables.settings.pageType
    : '';

  var blockedExactPaths = {
    '/pages/customer-service': true,
    '/pages/kundeservice': true,
    '/pages/ccpa-opt-out': true
  };

  var blockedPageTypes = {
    captcha: true,
    password: true,
    policy: true
  };

  var blockedPathPatterns = [
    /(^|\/)account(\/|$)/,
    /(^|\/)admin(\/|$)/,
    /(^|\/)checkout(s)?(\/|$)/,
    /(^|\/)orders(\/|$)/,
    /(^|\/)pages\/.*xmlfeed/i,
    /(^|\/)pages\/.*product-xml-feed/i
  ];

  var shouldSkipVendors = blockedExactPaths[pathname] || blockedPageTypes[pageType];

  for (var i = 0; i < blockedPathPatterns.length && !shouldSkipVendors; i += 1) {
    shouldSkipVendors = blockedPathPatterns[i].test(pathname);
  }

  if (shouldSkipVendors) {
    return;
  }
  /* CYME CUSTOM END: page-type third-party vendor gate */

  function loadVendors(){
    if (window.__thirdPartyLoaded) return; window.__thirdPartyLoaded = true;

    // Ahrefs
    var s = document.createElement('script');
    s.src = 'https://analytics.ahrefs.com/analytics.js';
    s.async = true;
    s.setAttribute('data-key','3W+AUN5S/2nkxrIxy2zzKA');
    document.head.appendChild(s);

    // Partner ads
    var p = document.createElement('script');
    p.src = 'https://partnertrackshopify.dk/js/register.js';
    p.async = true;
    document.head.appendChild(p);

    // Retargeted ai
    var p = document.createElement('script');
    p.src = 'https://s.retargeted.co/1/xpG3dB.js';
    p.async = true;
    document.head.appendChild(p);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadVendors, { timeout: 3000 });
  } else {
    function onLoad(){ loadVendors(); window.removeEventListener('load', onLoad, false); }
    window.addEventListener('load', onLoad, false);
  }
})();
